<template>
  <div class="center-page">
    <van-nav-bar style="background: transparent" class="nav" :border="false" @click-left="$store.dispatch('back')" placeholder>
      <template #left>
       <van-icon size="40rpx" name="arrow-left" color="#000"/>
      </template>
    </van-nav-bar>
    <div class="header">
      <div class="bg"  :style="{backgroundImage:`url(${userInfo.cover || user.userface || 'https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/default_avatar.png'})`}"></div>
        <div class="userInfo">
          <div class="avatar"
            :style="{backgroundImage:`url(${userInfo.cover || user.userface || 'https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/default_avatar.png'})`}"
          ></div>
          
          <div class="user" @click="toPage('./setting')">
            <p class="name">{{user.nickname}}</p>
            账号：{{ user.mobile }} <van-icon name="arrow" color="#999999" size="5"/>
          </div>
          <a class="serviceTel" href="tel:13811674685">
            
            <img src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/H5/%E5%AE%A2%E6%9C%8D%402x.png"/>
          </a>
        </div>
        <div class="studyTimedata" v-if="info">
          <div class="item">
            <p class="value">{{info.total_time}}</p>
            <p class="label">累计学习(分钟)</p>
          </div>
          <div class="item">
            <p class="value">{{info.day_number}}</p>
            <p class="label">连续学习(天)</p>
          </div>
          <div class="item">
            <p class="value">{{info.today_time}}</p>
            <p class="label">今日学习(分钟)</p>
          </div>
          
          <div class="item">
            <p class="value">{{info.lesson_number}}</p>
            <p class="label">完成课程(节)</p>
          </div>
        </div>
        <div class="menu">
            <div class="menuItem" v-for="(item,index) in menuList" :key="index" @click="toPage(item.url)">
              <img :src="item.img"/>
              <p class="text">{{ item.text }}</p>
              <p class="img"><img src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/H5/%E8%BF%9B%E5%85%A5%402x.png"/></p>
            </div>
        </div>
      
    </div>
    <div class="title">
      <p>学习记录</p>
      <p class="btn" @click="toPage('./purchased')">已购课程<img src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/H5/%E8%BF%9B%E5%85%A5%402x.png"/></p>
    </div>
    <van-tabs @change="getList"  class="myTabs" active="1" color="#000000" title-inactive-color="#999999" title-active-colo="#000" line-width="16" background="#F9F9F9"  :ellipsis="false">
      <van-tab :title="item.category_name" v-for="(item, index) of tabList" :key="index" :name="index+1" >
        
      </van-tab>
    </van-tabs>
    <div class="record">
      
      <div class="list">
        <List
          :loading="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="loadmore"
          class="content"
          v-if="list.length"
        >
          <div class="card" v-for="(item,index) in list" :key="index" @click="toDetail(item)">
            <img
              :src="item.cover || $placeImg"
              alt=""
              class="cover"
            />
            <div class="right">
              <div class="card-name ellipsis">
                {{item.name}}
              </div>
              <div class="pro">
                共{{item.total_lesson_number}}节/已学{{ item.lesson_number }}学时
              </div>
            
              <div class="lesson">
                <span>{{item.fen == 0 ? item.fen+'%' : item.fen}}</span>
                <div class="go">学习</div>
              </div>
            </div>
            
          </div>
        </List>
        <div class="nodata" style="height: calc(100vh - 550px);" v-else>
          <img
            src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/H5/%E5%AD%A6%E4%B9%A0%E8%AE%B0%E5%BD%95%402x.png"
            alt=""
          />
          <p>还没有学习记录</p>
          <span>日日行不怕千万里，常常做不怕千万事</span>
        </div>
      </div>
    </div>
    <!-- <sub-footer></sub-footer> -->
  </div>
</template>


<script>
import List from "vant/es/list/index";
import "vant/es/list/style/index";
import SubFooter from "@/components/YingyouTab";

export default {
  components: {
    List,
    SubFooter
  },
  computed: {
     user() {
      return localStorage.getItem('userdata') ? JSON.parse(localStorage.getItem('userdata')) : '';
    },
    flat() {
      return this.$store.state.plat_id
    }
  },
  data() {
    return {
      tabList:[],
      userInfo:{},
      menuList:[{
        text: '我的订单',
        img: 'https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/H5/%E8%AE%A2%E5%8D%95%402x.png',
        url:'../orderYingyou/orderList'
      },{
        text: '学习证书',
        img: 'https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/H5/%E8%AF%81%E4%B9%A6%402x.png',
        url:'../certList'
      },{
        text: '课程兑换',
        img: 'https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/H5/%E8%AF%BE%E7%A8%8B%E5%85%91%E6%8D%A2.png',
        url:'../exchange'
      },{
        text: '证书查询',
        img: 'https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/H5/%E8%AF%81%E4%B9%A6%E6%9F%A5%E8%AF%A2.png',
        url:'../certForm'
      }],
      time: 0,
      page: 1,
      list: [],
      limit: 10,
      loading: false,
      finished: false,
      activeIndex:0,
      trainList: [],
      info:null,
    };
  },
 
  async mounted () {
    let res = await this.$request.userInfo();
        this.pageLoading = false;
        if (res.code == 0) {
          this.userInfo = res.data;
        } else {
          this.$toast(res.msg);
        }
    this.getStudy()
    this.getCat()
  },
  methods: {
    async getStudy(){
        let res = await this.$api({
          method: 'post',
          url: '/api/flatform/record/list',
          data: {
             flat_id: this.$store.state.plat.id,
             category_id: 0
          }
       });
       if (res.code == 0) {
        this.info = res.data
       }
    },
   
    getCat(){
      this.$request.tuoyuCategory({ flat_id: this.$store.state.plat.id }).then((res) => {
        this.tabList = res.data
        this.getList(1);
      });
    },
    getList(index){
      this.$request
        .tuoyuStudy({
          flat_id: this.$store.state.plat.id,
          category_id: this.tabList[index-1].category_id,
        })
        .then((res) => {
          this.list = res.data.list;
        });
    },
    toDetail(item){
      let url = '../detailYingyou?id='+item.goods_id+'&type=video&lessonId='+item.lesson_id
      this.$router.push({
        path:url
      })
    },
    toPage(url){
      this.$router.push({
        path:url
      })
    },
    loadmore(){

    }
  },
};
</script>
<style lang="scss">
.center-page .nav{
  position: fixed;
  z-index: 10;
}
</style>
<style scoped lang="scss">
.center-page {
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  >div{
    background: #F9F9F9;
  }
}

.header {
  background: inherit !important;
  width: 100%;
  box-sizing: border-box;
  position: relative;
  &::before{
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: #F9F9F9;
    opacity: 0.7;
    filter: blur(50px);
    z-index: -1;
  }
  .bg{
    position: absolute;
    background-color: #F9F9F9;
    background-repeat: no-repeat;
    background-position: top center;
    background-size: 100% 100%;
    width: 100%;
    height: 100%;
    filter: blur(100px);
    top: 0;
    z-index: -2;
  }
  .userInfo{
    padding-top: 160px;
    display: flex;
    align-items: center;
    .avatar{
      width: 160px;
      height: 160px;
      border-radius: 12px;
      overflow: hidden;
      margin-left: 38px;
      margin-right: 30px;
      background-repeat: no-repeat;
      background-position: top center;
      background-size: cover;
    }
    .user {
      font-size: 24px;
      font-weight: 400;
      color: #999999;
      line-height: 34px;
      flex: 1;
      .name {
        font-size: 48px;
        font-weight: 500;
        color: #000000;
        line-height: 66px;
        padding-bottom: 10px;
      }
    }
    .serviceTel{
      width: 128px;
      height: 80px;
      line-height: 80px;
      background: #FFFFFF;
      border-radius: 100px 0px 0px 100px;
      display: flex;
      align-items: center;
      img{
        width: 54px;
        margin-left: 14px;
      }
    }

  }
}

.studyTimedata {
  width: 690px;
  border-radius: 12px;
  margin: 100px auto 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 35px;
  box-sizing: border-box;
}

.studyTimedata .value {
  font-size: 44px;
  font-weight: bold;
  color: #000000;
  line-height: 52px;
}

.studyTimedata .label {
  color: #666;
  font-size: 20px;
  margin-top: 20px;
  font-weight: 400;
}
.menu{
  width: 100%;
  background: linear-gradient(180deg, rgba(249,249,249,0) 0%, #F9F9F9 100%);
  padding: 40px 32px;
  .menuItem{
    &:nth-of-type(2n+1){
      margin-right: 22px;
    }
    &:nth-of-type(-n+2){
      margin-bottom: 22px;
    }
    width: calc((100% - 22px)*0.5);
    height: 116px;
    background: #FFFFFF;
    border-radius: 12px;
    display: flex;
    align-items: center;
    .text{
      flex: 1;
      font-size: 28px;
      color: #333333;
      font-weight: 500;
    }
    >img{
      width: 32px;
      margin-left: 28px;
      margin-right: 4px;
    }
    .img{
      width: 48px;
      height: 48px;
      background: #F5F5F5;
      border-radius: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 24px;
      img{
        width: 20px;
      }
    }
  }
}
.title{
    display: flex;
    align-items: center;
    padding: 42px 32px 16px;
    p:first-of-type{
      flex: 1;
      font-size: 36px;
      font-weight: 500;
      color: #000000;
      line-height: 36px;
      -webkit-text-stroke: 1px #979797;
      text-stroke: 1px #979797;
    }
    .btn{
        font-size: 24px;
        font-weight: 400;
        color: #999999;
        line-height: 32px;
        display: flex;
        align-items: center;
        img{
          width: 16px;
          margin-left: 16px;
        }
      }
  }
.record {
  height: 100%;
  padding-bottom: 20px;
  box-sizing: border-box;
  
  flex:1;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  
  
}



.list {
  // height: calc(100% - 90px);
}

.card {
  width: 690px;
  background: #f7f8fa;
  border-radius: 12px;
  margin: 32px auto 20px;
  box-sizing: border-box;
  display: flex;
}

.cover {
  width: 256px;
  height: 144px;
  border-radius: 8px;
  margin-right: 24px;
  flex-shrink: 0;
}
.right{
  flex: 1;
  display: flex;
  flex-direction: column;
}
.card-name {
  width: 410px;
  overflow: hidden;
  font-size: 28px;
  font-weight: 500;
  color: #333333;
  line-height: 40px;
}

.pro {
  font-size: 20px;
  font-weight: 400;
  color: #999999;
  line-height: 28px;
  padding-top: 10px;
  flex: 1;
}



.lesson {
  font-size: 28px;
  display: flex;
  align-items: center;
  font-weight: 500;
  color: #F08E00;
  justify-content: space-between;
}
.lesson span{
  font-size: 24px;
}

.go {
  background: #fff;
  border-radius: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  width: 96px;
  height: 48px;
  border-radius: 24px;
}

.lesson-name {
  flex: 0 1 auto;
}
</style>